<div class="tw-flex tw-flex-col tw-w-full xl:tw-px-[30px] lg:tw-px-[20px]">
    <div class="tw-text-[16px] tw-text-[#000000] tw-font-semibold">
        <span>{{ "PROFILE.USER_INFO" | translate }}</span>
    </div>
    <form
        [formGroup]="profileForm"
        (ngSubmit)="onProfileFormSubmit(profileForm.value)"
    >
        <div
            class="tw-flex tw-flex-col-reverse tw-gap-5 md:tw-flex-row tw-justify-between tw-items-start tw-my-[20px]"
        >
            <div class="tw-flex tw-items-center tw-gap-6">
                <div
                    class="tw-relative tw-h-[114px] tw-w-[114px] tw-min-h-[114px] tw-min-w-[114px] tw-rounded-full"
                >
                    <input
                        type="file"
                        accept="image/*"
                        (change)="onImageSelected($event)"
                        #fileInput
                        class="tw-hidden"
                    />

                    <!-- Clickable image preview -->
                    <img
                        [src]="
                            previewImageUrl ||
                            '/assets/images/user-placeholder.png'
                        "
                        class="tw-h-[114px] tw-w-[114px] tw-min-h-[114px] tw-min-w-[114px] tw-rounded-full tw-cursor-pointer tw-border-[1px] tw-border-gray-400"
                        alt="User image"
                        (click)="fileInput.click()"
                    />

                    <!-- Edit icon -->
                    <img
                        src="/assets/images/icons/img-edit.png"
                        class="tw-absolute tw-top-[5px] tw-right-[5px] tw-h-[26px] tw-w-[26px] tw-cursor-pointer"
                        alt="edit"
                        (click)="fileInput.click()"
                    />
                </div>

                <div
                    class="tw-flex tw-flex-col tw-max-w-[207px] md:tw-max-w-[305px] lg:tw-max-w-fit tw-flex-wrap tw-gap-[10px]"
                >
                    <div class="tw-flex tw-flex-col tw-gap-1">
                        <span
                            class="!tw-text-[18px] !tw-font-semibold tw-flex-2 tw-break-words"
                        >
                            {{ userData?.username }}
                        </span>
                        <span
                            class="tw-text-[#7B7575] tw-font-[500] tw-flex-1 tw-break-all tw-whitespace-normal tw-w-full tw-inline-block"
                        >
                            {{ userData?.email }}
                        </span>
                    </div>
                    <div class="tw-flex tw-flex-col tw-gap-1">
                        <span
                            class="!tw-text-[18px] !tw-font-semibold tw-flex-2 tw-break-words"
                        >
                            {{ "PROFILE.REFER.CODE_LABEL" | translate }}
                        </span>
                        <button
                            type="button"
                            (click)="copyReferralCode()"
                            class="tw-bg-[#FF8819] tw-cursor-pointer tw-text-white tw-rounded-full tw-py-2 tw-px-5 tw-gap-5 tw-w-fit tw-flex tw-items-center tw-justify-between"
                        >
                            <span
                                class="tw-font-semibold tw-text-sm tw-uppercase"
                                >{{ userData?.username }}</span
                            >
                            <svg
                                *ngIf="!copied"
                                width="15"
                                height="17"
                                viewBox="0 0 15 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M1.40625 14.875C1.40625 15.2977 1.55441 15.7031 1.81813 16.002C2.08185 16.3008 2.43954 16.4688 2.8125 16.4688H9.375C9.74796 16.4688 10.1056 16.3008 10.3694 16.002C10.6331 15.7031 10.7812 15.2977 10.7812 14.875V14.3438H12.1875C12.5605 14.3438 12.9181 14.1758 13.1819 13.877C13.4456 13.5781 13.5938 13.1727 13.5938 12.75V2.125C13.5938 1.70231 13.4456 1.29693 13.1819 0.998049C12.9181 0.699162 12.5605 0.53125 12.1875 0.53125H5.625C5.25204 0.53125 4.89435 0.699162 4.63063 0.998049C4.36691 1.29693 4.21875 1.70231 4.21875 2.125V2.65625H2.8125C2.43954 2.65625 2.08185 2.82416 1.81813 3.12305C1.55441 3.42193 1.40625 3.82731 1.40625 4.25V14.875ZM5.15625 2.125C5.15625 1.9841 5.20564 1.84898 5.29354 1.74935C5.38145 1.64972 5.50068 1.59375 5.625 1.59375H12.1875C12.3118 1.59375 12.431 1.64972 12.519 1.74935C12.6069 1.84898 12.6562 1.9841 12.6562 2.125V12.75C12.6562 12.8909 12.6069 13.026 12.519 13.1257C12.431 13.2253 12.3118 13.2812 12.1875 13.2812H10.7812V4.25C10.7812 3.82731 10.6331 3.42193 10.3694 3.12305C10.1056 2.82416 9.74796 2.65625 9.375 2.65625H5.15625V2.125ZM2.34375 4.25C2.34375 4.1091 2.39314 3.97398 2.48104 3.87435C2.56895 3.77472 2.68818 3.71875 2.8125 3.71875H9.375C9.49932 3.71875 9.61855 3.77472 9.70646 3.87435C9.79436 3.97398 9.84375 4.1091 9.84375 4.25V14.875C9.84375 15.0159 9.79436 15.151 9.70646 15.2507C9.61855 15.3503 9.49932 15.4062 9.375 15.4062H2.8125C2.68818 15.4062 2.56895 15.3503 2.48104 15.2507C2.39314 15.151 2.34375 15.0159 2.34375 14.875V4.25Z"
                                    fill="white"
                                />
                            </svg>

                            <mat-icon *ngIf="copied">check</mat-icon>
                        </button>
                    </div>
                </div>
            </div>

            <div
                class="tw-flex tw-items-center tw-gap-3 tw-ml-auto tw-mt-[-45px] md:tw-m-0"
            >
                <button
                    *ngIf="!isEditing"
                    (click)="onEditProfile()"
                    class="tw-py-[10px] tw-px-[20px] tw-rounded-full tw-bg-[#0A0A75] tw-text-white tw-w-auto tw-inline-block tw-whitespace-nowrap"
                >
                    {{ "PROFILE.EDIT_PROFILE" | translate }}
                </button>
                <button
                    *ngIf="isEditing"
                    (click)="onCancelProfileDetails()"
                    class="tw-py-[6px] tw-px-4 md:tw-py-[10px] md:tw-px-6 tw-rounded-full tw-text-[16px] tw-font-bold tw-bg-[#0000001A] tw-text-[#00000066]"
                >
                    {{ "CANCEL" | translate }}
                </button>
                <button
                    *ngIf="isEditing"
                    class="tw-py-[6px] tw-px-4 md:tw-py-[10px] md:tw-px-6 tw-rounded-full tw-text-[16px] tw-font-bold tw-bg-[#0A0A75] tw-text-white"
                    type="submit"
                >
                    {{ "COMMON.SAVE" | translate }}
                </button>
            </div>
        </div>
        <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-[20px]">
            <revamp-input-general
                class="tw-block"
                [applyDisableText]="true"
                [backgroundOverride]="'!tw-bg-[#f4f2f0]'"
                [mandatoryField]="true"
                [label]="'FORM.USERID' | translate"
                [controlName]="'username'"
                [placeHolder]="'NEW_APPLICATION.TYPE_HERE' | translate"
                [errors]="
                    getErrorsProfile('username', 'FORM.USERID' | translate)
                "
            ></revamp-input-general>
            <revamp-input-general
                class="tw-block"
                [applyDisableText]="!isEditing"
                [backgroundOverride]="isEditing ? '' : '!tw-bg-[#f4f2f0]'"
                [mandatoryField]="true"
                [label]="'FORM.FULL_NAME' | translate"
                [controlName]="'fullname'"
                [placeHolder]="'NEW_APPLICATION.TYPE_HERE' | translate"
                [errors]="
                    getErrorsProfile('fullname', 'FORM.FULL_NAME' | translate)
                "
            ></revamp-input-general>
            <revamp-input-general
                class="tw-block"
                [applyDisableText]="true"
                [backgroundOverride]="'!tw-bg-[#f4f2f0]'"
                [mandatoryField]="true"
                [label]="'FORM.EMAIL' | translate"
                [controlName]="'email'"
                [placeHolder]="'NEW_APPLICATION.TYPE_HERE' | translate"
                [errors]="getErrorsProfile('email', 'FORM.EMAIL' | translate)"
            ></revamp-input-general>
            <revamp-select-general
                class="tw-block tw-w-[100%]"
                [applyDisableText]="!isEditing"
                [backgroundOverride]="isEditing ? '' : '!tw-bg-[#f4f2f0]'"
                [options]="genderTypeOptions"
                [mandatoryField]="true"
                [label]="'FORM.GENDER' | translate"
                [controlName]="'gender'"
                [placeHolder]="
                    'NEW_APPLICATION.DROPDOWN_PLACEHOLDER' | translate
                "
                [currentValue]="profileForm.get('gender')?.value ?? ''"
                (selectionChange)="handleGenderTypeOptions($event)"
                [disabled]="profileForm.get('gender')?.disabled"
                [errors]="getErrorsProfile('gender', 'FORM.GENDER' | translate)"
                [isDropdownOpen]="toggleDropDown[0]"
            />
            <revamp-input-general
                class="tw-block"
                [applyDisableText]="!isEditing"
                [backgroundOverride]="isEditing ? '' : '!tw-bg-[#f4f2f0]'"
                [mandatoryField]="true"
                [label]="'COMMON.MOBILE' | translate"
                [placeHolder]="'(xxx xxxx)'"
                [verifyMobileButton]="showVerifyMobileBtn"
                [controlName]="'phoneNumber'"
                [errors]="
                    getErrorsProfile('phoneNumber', 'COMMON.MOBILE' | translate)
                "
                [phoneNoCodeLabel]="'+60'"
                (verifyMobile)="verifyMobile($event)"
            ></revamp-input-general>
        </div>
    </form>
</div>
